// Frontend/src/pages/auth/LogoutPage.tsx
import { useEffect } from "react";
import { clearAccessToken } from "@/api/client";
import { logout as apiLogout } from "@/api/auth";
import { queryClient } from "@/lib/queryClient";
import { useLanguage } from "@/contexts/LanguageContext";

export default function LogoutPage() {
  const { t } = useLanguage();

  useEffect(() => {
    void (async () => {
      try {
        // Clear refresh cookie on server.
        await apiLogout();
      } catch (error) {
        console.warn('Server logout failed, continuing with local cleanup:', error);
      } finally {
        // Always clear local auth state.
        clearAccessToken();
        sessionStorage.clear();
        localStorage.removeItem('resident_access_token');
        localStorage.removeItem('resident_refresh_token');
        localStorage.removeItem('resident_id');
        localStorage.removeItem('resident_name');
        localStorage.removeItem('resident_email');
        queryClient.clear();

        // Force reload to clear any cached state.
        window.location.href = "/#/login";
      }
    })();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mx-auto mb-4"></div>
        <p className="text-gray-600">{t("auth.loggingOut")}</p>
      </div>
    </div>
  );
}
